<template>
  <v-dialog v-model="show" persistent lazy max-width="600">
    <v-card>
      <v-card-title class="title">Ссылка для публичного доступа</v-card-title>
      <v-card-text>
        <v-form v-if="document">
          <v-text-field
                  v-model.trim="document.share_url"
                  @focus="$event.target.select()"
                  label="Ссылка"></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="show = false">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DocumentShareDialog',
    props: ['value', 'document'],
    data () {
      return {
      }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (newValue) {
          if (!newValue) {
            this.$emit('close')
          }
        }
      }
    }
  }
</script>